/**
 * Compact relative-time formatter for the SavedAgo HUD pill. Returns
 * "Ns ago" / "Nm ago" / "Nh ago" / locale-formatted date depending on
 * how stale the timestamp is. Originally duplicated in TacticsBoard2D
 * and TacticsBoard3D — consolidated here so a future tweak (e.g.
 * "just now" under 5 s) lands once.
 */
export function formatSavedAgo(iso: string): string {
  const ms = Date.now() - new Date(iso).getTime();
  const s = Math.max(0, Math.round(ms / 1000));
  if (s < 60) return `${s}s ago`;
  const m = Math.round(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h}h ago`;
  return new Date(iso).toLocaleDateString();
}
